// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"QFB_X","menuItem":"QFB_X"};